import store from '../store/store';

export default function getIsOnlineMeetingLocationRowExpanded(): boolean {
    return store.viewState?.isOnlineMeetingLocationRowExpanded;
}
